import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import clsx from "clsx";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { TextAndFourColumnCardsSliceFragment } from "../../types/graphql";
import { IPageContext } from "../../types/types";
import { htmlSerializer } from "../../utils/htmlSerializer";
import { SharedSliceType } from "../shared-slice/shared-slice";

export type ITextAndFourColumnCardsProps = Slice<
  SharedSliceType,
  TextAndFourColumnCardsSliceFragment["primary"],
  TextAndFourColumnCardsSliceFragment["items"][number]
> & { type: SharedSliceType.text_and_four_column_cards };

const TextAndFourColumnCards = ({
  slice,
}: SliceComponentProps<ITextAndFourColumnCardsProps, IPageContext>) => {
  const { primary, items } = slice;

  // Default is four columns
  let cardClass = "col-span-4 md:!col-span-4 xl:!col-span-3";

  switch (primary?.columns) {
    case "3":
      cardClass = "col-span-4 md:!col-span-4 xl:!col-span-4";
      break;
    case "2":
      cardClass = "col-span-4 md:!col-span-4 xl:!col-span-6";
      break;
  }
  return (
    (primary && (
      <section className="slice-section !pb-0">
        <div className="container md:border-b-1">
          <div className="!grid gap-16 pb-16">
            <div className="text-center">
              <PrismicRichText
                field={primary.primary_heading.richText}
                components={htmlSerializer}
              />
              <div className="intro">
                {primary.primary_description && (
                  <PrismicRichText
                    field={primary.primary_description.richText}
                    components={htmlSerializer}
                  />
                )}
              </div>
            </div>
            <div
              className={clsx([
                "!grid !grid-cols-4 md:!grid-cols-8 lg:!grid-cols-12",
                "p-0 m-0 list-none [&_.card]:lg:border-r-1 [&_.card]:lg:border-[#092C47] [&_.card]:lg:last:border-none",
              ])}
            >
              {items &&
                items.map((item) => (
                  <div className={clsx([cardClass, "card m-0 px-4"])}>
                    <div className="!grid justify-items-center gap-8 px-4 py-8 [&_h6]:!mb-2">
                      <div className="image">
                        <GatsbyImage
                          image={item.icon?.gatsbyImageData}
                          alt={item.icon?.alt || "Xometry Resources"}
                          loading="lazy"
                          className="[&_img]:!object-contain"
                        />
                      </div>
                      <div className="text text-center text-xom-dark-75">
                        <PrismicRichText
                          field={item.heading.richText}
                          components={htmlSerializer}
                        />
                        {item.description && (
                          <PrismicRichText
                            field={item.description.richText}
                            components={htmlSerializer}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
    )) || <></>
  );
};
export default TextAndFourColumnCards;
